
import { GoogleGenAI, Type } from "@google/genai";
import { AnalysisResult } from "../types";

// Initialize the GoogleGenAI client using the mandatory environment variable.
const ai = new GoogleGenAI({ apiKey: import.meta.env.API_KEY || "dummy-key" });

export const analyzeQuotation = async (fileName: string): Promise<AnalysisResult> => {
  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: `The user has uploaded a car dealership quotation from India named "${fileName}" to the platform "dealmycar". Generate a creative response including a "Guaranteed Minimum Discount" percentage (at least 1% higher than what they probably got) and a witty message about why they should choose dealmycar over the local showroom. Use Indian Rupee (₹) context.`,
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            estimatedSavings: { type: Type.STRING },
            message: { type: Type.STRING },
            guaranteedDiscount: { type: Type.STRING }
          },
          required: ["estimatedSavings", "message", "guaranteedDiscount"]
        }
      }
    });

    // Access the generated text using the .text property as per guidelines.
    const jsonStr = response.text?.trim() || "{}";
    const result = JSON.parse(jsonStr);
    return result as AnalysisResult;
  } catch (error) {
    console.error("Gemini analysis failed:", error);
    // Return a fallback result to ensure graceful UI degradation.
    return {
      estimatedSavings: "₹25,000",
      message: "We've analyzed your quote. Our dealmycar network can definitely offer a better on-road price.",
      guaranteedDiscount: "1.2%"
    };
  }
};
